import * as React from 'react';
import { PageChorinitia } from '../genericComponents/Page/PageChorinitia';
import { UserRole } from '../../types/UserRole';
import * as ReqType from '../../types/ServerRequests';
import { MediaService } from '../../services/MediaService';
import { TagCard } from '../genericComponents/Tag/TagCard';
import { LoaderButton } from '../genericComponents/Button/LoaderButton';
import LoginServices from '../../services/LoginServices';

interface Props {
    match: {
        path: string,
        url: string,
        isExact: boolean,
        params: {
            id: string
        }
    };
}

interface State {
    media?: ReqType.Media;
    ownedTags: ReqType.Tag[];
}

/**
 * Ce composant permet l'affichage d'un media en particulier sur une page
 */
export class DisplayMediaPage extends React.Component {
    props: Props;
    state: State;

    constructor(props: Props) {
        super(props);
        this.state = {
            ownedTags: []
        };
        this.getMedia();
        var userRole = LoginServices.getInstance().getType();
        if (userRole === UserRole.ADMIN.toString()) {
            this.getOwnedTags();
        }
    }

    render() {
        return (
            <PageChorinitia
                allowedUsers={[
                    UserRole.ADMIN,
                    UserRole.MEMBER,
                    UserRole.SEMI_PRO,
                    UserRole.USER,
                ]}
            >
                <div>
                    {this.displayTitre()}
                    {this.displayMedia()}
                    {this.displayDescription()}
                    {this.displayTags()}
                </div>
            </PageChorinitia>
        );
    }

    private getOwnedTags() {
        MediaService.getInstance().getTags(Number.parseInt(this.props.match.params.id))
            .then(
                (m: ReqType.Tag[]) => {
                    this.setState({ ownedTags: m });
                }
            );
    }

    private getMedia() {
        MediaService.getInstance().getMedia(Number.parseInt(this.props.match.params.id))
            .then(
                (m: ReqType.Media) => {
                    this.setState({ media: m });
                }
            );
    }

    private displayTitre(): JSX.Element | undefined {
        if (this.state.media !== undefined) {
            return (
                <div className="row form-group d-flex justify-content-between">
                    <div className="row col-6" style={{marginLeft: '15px'}}>
                        <h3  style={{marginTop: '20px', marginRight: '10px'}} >Titre: </h3>
                        <input
                            className="form-control col-6"
                            style={{marginTop: '20px'}}
                            value={this.state.media === undefined ? '' : this.state.media.nom}
                            onChange={
                                (e: React.ChangeEvent<HTMLInputElement>) => {
                                    if (this.state.media !== undefined) {
                                        this.state.media.nom = e.target.value;
                                        this.setState({ media: this.state.media });
                                    }
                                }
                            }
                        />
                    </div>
                    <LoaderButton
                        className="btn"
                        style={{marginTop: '20px', marginRight: '30px'}}
                        onClick={
                            () => {
                                if (this.state.media !== undefined) {
                                    return (MediaService.getInstance().updateMedia(this.state.media));
                                } else {
                                    return Promise.reject('');
                                }
                            }
                        }
                    >
                        Enregistrer
                    </LoaderButton>
                </div>
            );
        } else {
            return undefined;
        }
    }

    private displayMedia(): JSX.Element | undefined {
        if (this.state.media !== undefined) {
            if (this.state.media.type_media_id === ReqType.Type_Media.VIDEO) {
                return (
                    <video controls={true} className="col-12">
                        <source
                            src={
                                MediaService.getInstance().getBaseURL() +
                                this.state.media.lien
                            }
                            type="video/mp4"
                        />
                    </video>
                );
            } else {
                return (
                    <img
                        className="col-12"
                        src={
                            MediaService.getInstance().getBaseURL() +
                            this.state.media.lien
                        }
                    />
                );
            }
        } else {
            return undefined;
        }
    }

    private displayDescription(): JSX.Element | undefined {
        if (this.state.media !== undefined) {
            return (
                <div className="form-group">
                    <h3 style={{marginLeft: '15px', marginTop: '10px'}}>Description</h3>
                    <textarea
                        style={{marginTop: '5px', marginLeft: '15px', width: '97%'}}
                        className="form-control"
                        id="exampleFormControlTextarea1"
                        rows={3}
                        value={this.state.media === undefined ? '' : this.state.media.description}
                        onChange={
                            (e: React.ChangeEvent<HTMLTextAreaElement>) => {
                                if (this.state.media !== undefined) {
                                    this.state.media.description = e.target.value;
                                    this.setState({ media: this.state.media });
                                }
                            }
                        }
                    />
                    <LoaderButton
                        className="btn"
                        style={{marginTop: '20px', marginLeft: '15px'}}
                        onClick={
                            () => {
                                if (this.state.media !== undefined) {
                                    return (MediaService.getInstance().updateMedia(this.state.media));
                                } else {
                                    return Promise.reject('');
                                }
                            }
                        }
                    >
                        Enregistrer
                    </LoaderButton>
                </div>
            );
        } else {
            return undefined;
        }
    }

    private displayTags(): JSX.Element | undefined {
        var userRole = LoginServices.getInstance().getType();
        if (userRole !== UserRole.ADMIN.toString()) {
            return undefined;
        }
        return (
            <div style={{marginLeft: '15px', marginRight: '15px', marginBottom: '20px'}}>
                <TagCard
                    ownedTags={this.state.ownedTags}
                    setOwned={
                        (tags: ReqType.Tag[]) => {
                            this.setState({ ownedTags: tags });
                        }
                    }
                    addTag={
                        (tag: ReqType.Tag) => {
                            return MediaService
                                .getInstance()
                                .addTag(Number.parseInt(this.props.match.params.id), tag.id);
                        }
                    }
                    removeTag={
                        (tag: ReqType.Tag) => {
                            return MediaService
                                .getInstance()
                                .removeTag(Number.parseInt(this.props.match.params.id), tag.id);
                        }
                    }
                />
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/components/MediasPage/DisplayMediaPage.tsx